// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
var _FileGifOutlined = /*#__PURE__*/ _interop_require_default(require("@ant-design/icons-svg/lib/asn/FileGifOutlined"));
var _AntdIcon = /*#__PURE__*/ _interop_require_default(require("../components/AntdIcon"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var FileGifOutlined = function(props, ref) {
    return /*#__PURE__*/ _react.createElement(_AntdIcon.default, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        icon: _FileGifOutlined.default
    }));
};
/**![file-gif](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik01NTEuNSA0OTAuNUg1MjFjLTQuNiAwLTguNCAzLjctOC40IDguNFY3MjBjMCA0LjYgMy43IDguNCA4LjQgOC40aDMwLjVjNC42IDAgOC40LTMuNyA4LjQtOC40VjQ5OC45Yy0uMS00LjYtMy44LTguNC04LjQtOC40ek00NzcuMyA2MDBoLTg4LjFjLTQuNiAwLTguNCAzLjctOC40IDguNHYyMy44YzAgNC42IDMuNyA4LjQgOC40IDguNGg0Ny42di43Yy0uNiAyOS45LTIzIDQ5LjgtNTYuNSA0OS44LTM5LjIgMC02My42LTMwLjctNjMuNi04MS40IDAtNTAuMSAyMy45LTgwLjYgNjIuMy04MC42IDI4LjEgMCA0Ny41IDEzLjUgNTUuNCAzOC4zbC45IDIuOGg0OS4ybC0uNy00LjZDNDc1LjkgNTE1LjkgNDM0LjcgNDg0IDM3OSA0ODRjLTY4LjggMC0xMTMgNDkuNC0xMTMgMTI1LjkgMCA3Ny41IDQzLjcgMTI2LjEgMTEzLjYgMTI2LjEgNjQuNCAwIDEwNi00MC4zIDEwNi0xMDIuOXYtMjQuOGMwLTQuNi0zLjctOC4zLTguMy04LjN6IiAvPjxwYXRoIGQ9Ik04NTQuNiAyODguNkw2MzkuNCA3My40Yy02LTYtMTQuMS05LjQtMjIuNi05LjRIMTkyYy0xNy43IDAtMzIgMTQuMy0zMiAzMnY4MzJjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjQwYzE3LjcgMCAzMi0xNC4zIDMyLTMyVjMxMS4zYzAtOC41LTMuNC0xNi43LTkuNC0yMi43ek02MDIgMTM3LjhMNzkwLjIgMzI2SDYwMlYxMzcuOHpNNzkyIDg4OEgyMzJWMTM2aDMwMnYyMTZhNDIgNDIgMCAwMDQyIDQyaDIxNnY0OTR6IiAvPjxwYXRoIGQ9Ik02MDguMiA3MjcuOGgzMi4zYzQuNiAwIDguNC0zLjcgOC40LTguNHYtODQuOGg4Ny44YzQuNiAwIDguNC0zLjcgOC40LTguNHYtMjUuNWMwLTQuNi0zLjctOC40LTguNC04LjRoLTg3Ljh2LTU4LjloOTYuOGM0LjYgMCA4LjQtMy43IDguNC04LjR2LTI2LjhjMC00LjYtMy43LTguNC04LjQtOC40SDYwOC4yYy00LjYgMC04LjQgMy43LTguNCA4LjR2MjIxLjFjMCA0LjggMy44IDguNSA4LjQgOC41eiIgLz48L3N2Zz4=) */ var RefIcon = /*#__PURE__*/ _react.forwardRef(FileGifOutlined);
if (process.env.NODE_ENV !== 'production') {
    RefIcon.displayName = 'FileGifOutlined';
}
var _default = RefIcon;
